import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../helpers/form/FormHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../helpers/form/FormData'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import MyButton from '../../../UI/form/MyButton'
import DepartmentTypeSelectMain from '../../../form/fields/DepartmentTypeSelectMain'
import DepartmentSelectMain from '../../../form/fields/DepartmentSelectMain'
import TextFieldMain from '../../../form/fields/TextFieldMain'
import WriteOffActItems from './items/WriteOffActFormItems'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { addWriteOffAct } from '../../../../store/writeOffSlice'
import { addWriteOffActAPI } from '../../../../api/writeOff/writeOffActAPI'
import WriteOffActDepartmentSelect from './fields/WriteOffActDepartmentSelect'
import InfoMessage from '../../../UI/messages/InfoMessage'

const WriteOffActForm = ({ writeOffActBd, setOpen }) => {

  const dispatch = useDispatch()

  	const [data, setData] = useState(writeOffActBd ? writeOffActBd : {}) // Дані з форми
          
	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [loading, setLoading] = useState(false)

	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [result, setResult] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setIsValidForm)
	}, [valid])

	const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        addWriteOffActAPI(dataForBd).then(data => {
            dispatch(addWriteOffAct(data))
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const edit = (dataForBd) => {
        // editSupplierAPI(dataForBd).then(data => {
        //     setOpen(false)
        //     setLoading(false)
        // }).catch(e => {
        //     setError(responseError(e))
        //     setLoading(false)
        // })
    }

    const setDataForBd = () => {
        let dataForBd = {
            departmentTypeId: data.departmentTypeId,
            departmentId: data.departmentId,
            description: data.description,
            items: data.items,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
		{/* {
			formDataProductIsField('departmentTypeId', 'writeOffAct') ?
				<DepartmentTypeSelectMain
					required={formDataProductRequiredField('departmentTypeId', 'writeOffAct')}
					setValidate={e => updateValidate(setValid, 'departmentTypeId', e)}
					setValueForm={e => setValueForm(setData, 'departmentTypeId', e)}
					forciblyValue={data && data.departmentTypeId ? data.departmentTypeId : ''}
				/>
			: ''
        } */}
		{/* {
			formDataProductIsField('departmentId', 'writeOffAct') ?
				<DepartmentSelectMain
                    // departmentTypeId={data.departmentTypeId}
					required={formDataProductRequiredField('departmentId', 'writeOffAct')}
					setValidate={e => updateValidate(setValid, 'departmentId', e)}
					setValueForm={e => setValueForm(setData, 'departmentId', e)}
					forciblyValue={data && data.departmentId ? data.departmentId : ''}
					withoutType={true}
				/>
			: ''
        } */}
		{
			formDataProductIsField('departmentId', 'writeOffAct') ?
				<WriteOffActDepartmentSelect
                    // departmentTypeId={data.departmentTypeId}
					required={formDataProductRequiredField('departmentId', 'writeOffAct')}
					setValidate={e => updateValidate(setValid, 'departmentId', e)}
					setValueForm={e => setValueForm(setData, 'departmentId', e)}
					forciblyValue={data && data.departmentId ? data.departmentId : ''}
					withoutType={true}
                    setItems={e => {setValueForm(setData, 'items', e)}}
				/>
			: ''
        }
		{
			formDataProductIsField('description', 'writeOffAct') ?
				<TextFieldMain
					required={formDataProductRequiredField('description', 'writeOffAct')}
					setValidate={e => updateValidate(setValid, 'description', e)}
					setValueForm={e => setValueForm(setData, 'description', e)}
					forciblyValue={data && data.description ? data.description : ''}
					label='Опис'
					placeholder='Введіть короткий опис'
				/>
			: ''
        }

		<p className='supplyOrder__header'>
            Позиції
        </p>

        {
            data && data.departmentId ?
                formDataProductIsField('items', 'writeOffAct') ?
                    <WriteOffActItems
                        departmentId={data.departmentId}
                        // supplyOrderItems={supplyOrderItems}
                        // supplyOrderItems={data.items}
                        required={formDataProductRequiredField('items', 'writeOffAct')}
                        setValidate={e => updateValidate(setValid, 'items', e)}
                        setValueForm={e => setValueForm(setData, 'items', e)}
                        forciblyValue={data && data.items ? data.items : ''}
                    />
                : ''
            : 
                <InfoMessage 
                    info={'Оберіть підрозділ'} 
                />
        }

		<ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
	</div>
  )
}

export default WriteOffActForm